import React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Dark } from '@mentimeter/ragnar-ui/themes';
import { Text } from '@mentimeter/ragnar-ui/text';

export const ContextMessage = ({
  text,
  shouldShow,
  icon,
  resetShowState,
}: {
  text: string;
  shouldShow: boolean;
  icon?: React.ReactElement<any> | undefined;
  resetShowState?: () => void;
}) => {
  const [isVisible, setIsVisible] = React.useState(true);

  React.useEffect(() => {
    if (shouldShow) setIsVisible(true);
    const timeout = setTimeout(() => {
      setIsVisible(false);
      if (resetShowState) resetShowState();
    }, 4000);
    return () => {
      clearTimeout(timeout);
    };
  }, [shouldShow, resetShowState]);

  return (
    <Dark>
      <Box
        borderRadius="32px"
        bg="bg"
        px={3}
        py={2}
        ml={3}
        flexDirection="row"
        alignItems="center"
        aria-hidden={!isVisible || !shouldShow}
        extend={() => ({
          opacity: isVisible && shouldShow ? 1 : 0,
          transition: 'opacity 0.5s ease-in-out',
        })}
      >
        {icon && icon}
        <Box px={2} py={1}>
          <Text>{text}</Text>
        </Box>
      </Box>
    </Dark>
  );
};
